
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Toto přináší projekt
                    <a href="${0}">Folksonomy Engine</a>. Neváhejte se
                    zapojit nebo poskytnout zpětnou vazbu.`,
'h5d824b4954e56ea5': html`Naskenujte si své <span class="everyday">každodenní</span> <span class="foods">potraviny</span>`,
'h6bdd1b427aa985a4': html`Tento nástroj umožňuje opravit seznam ingrediencí. Můžete přidat, odebrat nebo upravit
                seznam ingrediencí.
                <br>
                Tento znak <span class="highlight">␣</span> představuje mezeru.
                <br>
                Tento znak <span class="highlight">↩︎</span> představuje zalomení řádku. `,
'hb28f1f2ec1744ee9': html`Tyto vlastnosti jsou vytvářeny a archivovány uživateli pro jakékoli použití. Nebojte se
                    přidat své vlastní. Vlastnosti a hodnoty, které vytvoříte
                    <strong>, musí být věcné</strong>. Můžete se ponořit do
                    <a href="${0}">seznamu vlastností, které již komunita používá</a>
                    nebo prozkoumat
                    <a href="${1}">dokumentaci k vlastnostem a jejich vyhledávač</a>.`,
's000a5b76bd3a01c2': `Načítání vlastností...`,
's000d98595e959c1e': `Získat na Google Play`,
's013bdc8cf0d3583d': `Pomozte nám s ingrediencemi`,
's01d2865e3e1d5501': `Děkujeme za vaši pomoc!`,
's02ce7a2e7c1b020b': `Ověřte plodinu`,
's03e9c8114521b998': `Upravím ingredience.`,
's05ec315d9308091a': `Ikona rohů čárového kódu`,
's061eb5af92512c85': `Uloženo! Můžete mi pomoct s dalším?`,
's06847c221c4c0bc1': `Chtěl bych vytvořit vlastnost pro [popište váš případ použití]...`,
's06f6c6f99db6b552': `Originál`,
's081e2ad82db71e1d': `Seskupené hodnoty`,
's09205907b5b56cda': `Ne`,
's0b4235aae602a950': `specializovaná dokumentace`,
's0bb2d48532acc455': `Stáhnout CSV`,
's0d5b7fee0311db68': `Vlastnosti`,
's0fb218abc2e157ed': `Zrušit platnost obrázku`,
's100c4928cc74642a': `podporovat pokrok ve výzkumu veřejného zdraví.`,
's10db5498186c083b': `Zrušit oříznutí`,
's11a18a69b30b65ed': `Pomozte nám opravit chyby v seznamu ingrediencí`,
's1205d5f6fccf8e69': `Hodnota nemovitosti`,
's15d64a0a6715285a': `Nový klíč`,
's166bd56d19670a72': `Přiblížit`,
's19059bf0c4f7c162': `Oblast výběru`,
's1a52515ec8ddade8': `Čárový kód produktu`,
's1c5031113de500ce': `udržování naší databáze otevřené &amp; dostupné všem,`,
's1dc4daf989c71284': `Pomozte nám opravit nutriční informace`,
's1e00019dc454872d': `Zadejte prosím název vlastnosti pomocí atributu property-name.`,
's1e49126af0935a5b': `Seznam produktů používajících tuto vlastnost`,
's21e73088de6f26f3': `Stáhnout v App Store`,
's255857544a9d5ec0': `Obnovit`,
's25e94495991e95ba': `Děkujeme za vaši pomoc! Můžete pomoci s jinou otázkou?`,
's2ceb11be2290bb1b': `Zrušit`,
's2db7b654c0a9bde0': `Zdokumentujte nemovitost`,
's300b3a6ee4e1252d': str`Špatná shoda ${0}%`,
's33f786bb6b4f0cf4': `Výsledek oříznutí`,
's33f85f24c0f5f008': `Uložit`,
's34be4af4e8fec4ae': `Nejprve se zeptejte komunity`,
's36d86adc823cbfa6': `Před vytvořením nové nemovitosti ji prodiskutujte s komunitou:`,
's3781d25aa51a736c': `Dokumentace k enginu Folksonomy`,
's383ae4449428b61e': `Obnovit oříznutí`,
's39bcf88721a1e8ee': `Obnovit výběr`,
's39e14e14300694c7': `Dokumentace a pokyny`,
's3b430cfa5c1fe7f4': str`Dokumentace pro ${0}`,
's3f4e4b52f230a892': `Obrazové plátno`,
's417b90913e05bc17': `Náhled`,
's41f7dca46d3f1b4a': `Hodnota`,
's422bba9636ce2489': `Středový obrázek`,
's42dd66b2441566fd': `Ikona středu`,
's43df2e8395f6834e': str`Prosím, přispějte na naši sbírku ${0}`,
's453188ea728f64da': `Přidejte živinu`,
's453ab0dbb9b5c777': `Změnit velikost vpravo`,
's475b08749d0706ed': `Pomozte nám informovat miliony spotřebitelů po celém světě o tom, co jedí`,
's49730f3d5751a433': `Načítání...`,
's4bbc7472834a9686': `Váš prohlížeč nepodporuje skenování čárových kódů.`,
's4d42cc7e00076a3b': `Počet produktů`,
's4df2f533c0c1e7d0': `Ovládací prvky obrazu`,
's4e94adf723979402': `Open Food Facts potřebuje vaši pomoc s tímto produktem.`,
's4f4886341969d552': `Přesunout výběr`,
's4f751fb9b3ed766c': `Vytvoření nové vlastnosti`,
's547c12ae169d00bc': `Dostupné na F-Droidu`,
's5560fb119e40923d': `Zadejte název nemovitosti...`,
's55d7249883a98ca1': `o této nemovitosti na wiki Open Food Facts`,
's565867d84c04aea2': `Filtrovat vlastnosti...`,
's5666afe5cd0166de': `Před potvrzením prosím opravte chyby nebo upravte text.`,
's57472465a23b41db': `Hodnoty`,
's58e1eeea7a60ae51': `Načítání produktů...`,
's59df20feee978e5b': `Chyba: Neplatná hodnota.`,
's5c92c0051d44b6de': `Pomozte nám opravit nutriční informace.`,
's5dd6f12783fca34f': `Upravit seznam ingrediencí`,
's5e8250fb85d64c23': `Zavřít`,
's5ed03bb1f3a15949': `Obrázek`,
's6306a31415aea913': `PODPORUJI`,
's6498dfe4855bb3a7': `jednotka`,
's64ef2a6c2dd1d3d1': `Upravit`,
's66413c24dcf680e2': `Přeskočit`,
's67ae6594857a4d57': `Děkujeme za Váš příspěvek!`,
's6cee7cad81dfedd1': `Oříznutý obrázek`,
's6d7b6cdedaadfb6e': `Každý dar se počítá! Vážíme si vaší podpory při zavádění další transparentnosti potravin ve světě.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Dobrá shoda ${0}%`,
's71a5c9f4b68ef4d4': `Počet`,
's74cb3d66f6a668e1': `Dokumentace`,
's787dd11bed0dc88a': `Změnit velikost vlevo`,
's7ce4fd9430e80cea': `hodnota`,
's801a05fa8e881f37': `Zjistěte více o vytváření nemovitostí a pokynech:`,
's8038273de2cf8b73': `Vyberte oblast, kterou chcete oříznout.`,
's839cc2908a5387f2': `Filtrovat čárové kódy...`,
's86197dcf3e96af64': `Procházejte a vyhledávejte existující nemovitosti`,
's8a63be30a129a59c': `Změnit velikost dolní části`,
's8a8bfd67f2dd2810': `Stáhněte si aplikaci OFF pomocí tohoto QR kódu`,
's8af61807443f32a4': `Akce`,
's8b33c244759d7bd4': `Změnit velikost vpravo nahoře`,
's8db84aa4bc949af2': `Zdokumentujte novou nemovitost`,
's8f839a03997a16d7': `Zobrazit produkt`,
's901ae1e236ac45d3': `Zrušit smazání`,
's907f7a97c6b29425': `Upozorňujeme, že datový model může být upraven. Používejte na vlastní nebezpečí.`,
's95d23d03f9147581': `Zrušit přiblížení`,
's976dfd19ef58a1e1': `Kliknutím naskenujete čárový kód a zjistíte jeho podrobnosti (stav, preference atd.)`,
's98ff35f2a00dc60d': `Složení:`,
's9a7f60fce090ecaf': `Načtení vlastností se nezdařilo. Zkuste to prosím znovu později.`,
's9b87abd68fb9df45': `Nenalezen? Vytvořte nový klíč {value}`,
's9c0f52425fd2f07e': `Nemusí se shodovat`,
's9fc41f789c63b40d': `Produkty`,
'sa1fa766e0d5634d7': `Žádné skóre k dispozici`,
'sa548778b24054030': `Prozkoumejte všechny vlastnosti poskytnuté projektem Folksonomy Engine. Tyto vlastnosti poskytují další metadata a informace o produktech v databázi Open Food Facts.`,
'sa63907958bd0ec4b': `Změnit velikost vlevo nahoře`,
'sa95b4224f685a36a': `Zavřít modální okno`,
'sab56a1d439576fd6': `Ikona návrhu`,
'sac47ea2901d04c15': `Změnit velikost vlevo dole`,
'sb125227d436c2925': `Vyhledejte si koncept nemovitosti v existující databázi nemovitostí:`,
'sb125568d43642e6f': `Odpovězte na otázky týkající se produktu.`,
'sb1c538e038f9b214': str`Velmi dobrá shoda ${0}%`,
'sb28639570ff3b852': `seznam všech nemovitostí`,
'sb3bdd638a58d30f4': `zapojit komunitu angažovaných občanů,`,
'sb3cbcc1bd0fff140': `Jakmile ověříte, že vaše vlastnost neexistuje a komunita souhlasí s její užitečností, musíte ji nejprve zdokumentovat na wiki.`,
'sb3d4f79d9d8b71e5': `Odeslat`,
'sb560fa37a7bfb6c2': `Pro tuto nemovitost nebyly nalezeny žádné produkty.`,
'sb7f72e4c8a2d3357': `Filtrovat hodnoty...`,
'sb8178320160f84ea': `Zobrazit oříznutí`,
'sbad7d2734149470b': `Ověřit`,
'sbb623d6b18d966a0': `Nutriční údaje jsou uvedeny na obalu:`,
'sbd6be5cde472f37c': `Všechny postřehy byly zodpovězeny! Děkuji za vaši pomoc!`,
'sbd9a0b2293b3cd3c': `Velikost porce`,
'sbe472dc3c2685985': `Odpovídající hodnota`,
'sc0520e1732a5c568': `Rozbalit obrázek`,
'sc0cc559e7ede852a': `Změnit velikost horní části`,
'sc1c08d0cbcc3bd24': `Neshoduje se`,
'sc52696641af72b53': `Nainstalujte aplikaci!`,
'sc5575e3107f87874': `Otočit obrázek doleva`,
'sc57b630a7a70c61f': `Navrhovaná oprava`,
'sc681b137e8f604f7': `Potvrdit odstranění`,
'sc6daf8a31883f8b9': `Přesunout obrázek`,
'sc895972c88d38ca5': `Majetek folksonomie`,
'sca0c3305aff570b8': str`na zadanou porci "${0}"`,
'scace072bef961918': `Řádky`,
'scb3b0671d7b7f640': `Nová hodnota`,
'scb489a1a173ac3f0': `Ano`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Zapojte se do diskuse na Slacku`,
'scdb6cad0b92721bf': `Nenalezeny žádné nemovitosti.`,
'scf23a05631f93732': `Potvrdit smazání`,
'scfed2f270ef6a3aa': `Vyberte oblast`,
'sd1022bc1ef9204f7': `Zvětšitelný obrázek`,
'sd1077c055cf9ba6b': `Pomozte nám ověřit seznam složek produktu.`,
'sd698d21ddecba56b': `Ahoj! Můžete nám pomoci vylepšit informace o produktech tím, že odpovíte na následující otázky:`,
'sd82bc2decefa621b': `zůstat nezávislí na potravinářském průmyslu,`,
'sdb97e5976482606e': `Zkontrolujte, zda již nemovitost existuje`,
'sdbf806fefc584115': `Měli byste najít`,
'sdc673e73b5c13aea': `Odstranit`,
'sdc792b75f1edcaba': `Pomozte nám opravit pravopis ingrediencí.`,
'sdca5deead576ceee': `Změnit velikost vpravo dole`,
'sdcc2555c5dde524f': `Opravdu chcete tuto položku smazat? Tuto akci nelze vrátit zpět.`,
'se206feec7ec57b28': `na 100 g`,
'se419a9ab36987490': `Zrušit platnost`,
'se5127cf0f92e7e48': `Tip: Můžete také najít`,
'se773f50d2a16d481': `Otočit obrázek vpravo`,
'sebb2c6c830a44574': `technická infrastruktura (web/mobilní aplikace) &amp; malý stálý tým`,
'sec6377f3c4e9b28c': `Navrhnu lepší úrodu`,
'seea3800e27baa686': `Jednotlivé produkty`,
'sefaba4adc4ec9219': `Vlastnosti Folksonomy`,
'seffa8ca49175b5f0': `Personalizované vlastnosti`,
'sf44a6b3b232c28ea': str`Nahraďte aktuální hodnotu hodnotou ${0}`,
'sf4cd86a2f5ef2588': `Čárový kód produktu`,
'sf57a61152168cc81': `Pomozte nám opravit detekci ingrediencí`,
'sf88b90b8ba23871c': `Neznámá shoda`,
'sf9aee319a006c9b4': `Přidat`,
'sfacbbe968fa7d773': `Název nemovitosti:`,
'sfc40ea3d5d5aa6f8': `Vaše dary financují každodenní provoz našeho neziskového sdružení:`,
'sfe87465d50530725': `Odpovídající hodnota`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  